// Frontend/src/services/paymentService.js
import api from './api';

const paymentService = {
  initiatePayment: async (paymentData) => {
    try {
      const response = await api.post('/payments/initiate', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error initiating payment:', error);
      throw error;
    }
  },

  getPaymentStatus: async (paymentId) => {
    try {
      const response = await api.get(`/payments/status/${paymentId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching payment status for ${paymentId}:`, error);
      throw error;
    }
  },

  // Helper function to redirect to PayFast with the correct data
  redirectToPayFast: (paymentDetails) => {
    const { payment_url, payment_data } = paymentDetails;
    
    // Create a form to post to PayFast
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = payment_url;
    
    // Add all the payment data as hidden inputs
    Object.keys(payment_data).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = payment_data[key];
      form.appendChild(input);
    });
    
    // Add the form to the body and submit it
    document.body.appendChild(form);
    form.submit();
    
    // Remove the form after submission
    setTimeout(() => {
      document.body.removeChild(form);
    }, 100);
  },

  getAllPayments: async () => {
    try {
      const response = await api.get('/payments/history');
      console.log('All payments fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching all payments:', error);
      throw error;
    }
  },

};

export default paymentService;